module.exports = __webpack_public_path__ + "static/img/AI诊股.bd25d9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AI诊股.jpg
// module id = nI7y
// module chunks = 3